module.exports = __webpack_public_path__ + "static/media/map-marker-predicted.905addba.svg";